<template>
    <div class="engine engine__dialog-flow">
        <div class="label">
          {{ $t('common.modals.create_external.engines.dialog-flow.googleDialogFlowSettings') }}
        </div>

        <div class="engine--description">
          {{ $t('common.modals.create_external.engines.dialog-flow.readMoreAbout') }}
          <a class="engine--info-url" :href="dialogFlowUrl" target="_blank">
            {{ $t('common.modals.create_external.engines.dialog-flow.here') }}
          </a>
        </div>

        <div class="type-select">
            <or-radio
                v-model="localDialogFlowModel.settings.type"
                :true-value="projectTypes.PROJECT"
            >
              {{ $t('common.modals.create_external.engines.dialog-flow.project') }}
            </or-radio>
            <or-radio
                v-model="localDialogFlowModel.settings.type"
                :true-value="projectTypes.USER"
            >
              {{ $t('common.modals.create_external.engines.dialog-flow.user') }}
            </or-radio>
            <or-radio
                v-model="localDialogFlowModel.settings.type"
                :true-value="projectTypes.ENVIRONMENT"
            >
              {{ $t('common.modals.create_external.engines.dialog-flow.environment') }}
            </or-radio>
        </div>

        <or-textbox
            v-model="localDialogFlowModel.settings.url"
            :label="$t('common.modals.create_external.engines.dialog-flow.url.label')"
            :placeholder="$t('common.modals.create_external.engines.dialog-flow.ulr.placeholder')"
        />

        <or-textbox
            v-if="dialogFlowModel.settings.type === projectTypes.USER"
            v-model="localDialogFlowModel.settings.userId"
            :label="$t('common.modals.create_external.engines.dialog-flow.userId.label')"
            :placeholder="$t('common.modals.create_external.engines.dialog-flow.userId.placeholder')"
        />

        <or-textbox
            v-else-if="dialogFlowModel.settings.type === projectTypes.PROJECT"
            v-model="localDialogFlowModel.settings.projectId"
            :label="$t('common.modals.create_external.engines.dialog-flow.projectId.label')"
            :placeholder="$t('common.modals.create_external.engines.dialog-flow.projectId.placeholder')"
        />

        <or-textbox
            v-else-if="dialogFlowModel.settings.type === projectTypes.ENVIRONMENT"
            v-model="localDialogFlowModel.settings.environmentId"
            :label="$t('common.modals.create_external.engines.dialog-flow.environmentId.label')"
            :placeholder="$t('common.modals.create_external.engines.dialog-flow.environmentId.placeholder')"
        />

        <or-textbox
            v-model="localDialogFlowModel.settings.bearerToken"
            :label="$t('common.modals.create_external.engines.dialog-flow.bearerToken.label')"
            :placeholder="$t('common.modals.create_external.engines.dialog-flow.bearerToken.placeholder')"
        />

        <or-code
            v-model="localDialogFlowModel.settings.queryParamsTemplate"
            :label="$t('common.modals.create_external.engines.dialog-flow.queryParamsTemplate.label')"
            :full-screen="false"
            mode="json"
        />

        <or-code
            v-model="localDialogFlowModel.settings.bodyTemplate"
            :label="$t('common.modals.create_external.engines.dialog-flow.bodyTemplate.label')"
            :full-screen="false"
            mode="json"
        />
    </div>
</template>

<script>
import { DIALOG_FLOW_DOCS_URL } from '@/config'

const DialogFlowProjectTypes = Object.freeze({
  PROJECT: 'project',
  USER: 'user',
  ENVIRONMENT: 'environment'
})

export const getDefaultDialogFlowSettings = () => ({
  url: '',
  bearerToken: '',
  userId: '',
  projectId: '',
  environmentId: '',
  type: DialogFlowProjectTypes.PROJECT,

  queryParamsTemplate: JSON.stringify({}),
  bodyTemplate: JSON.stringify({
    queryInput: {
      text: {
        languageCode: 'en'
      }
    },
    queryParams: {
      timeZone: 'GMT'
    }
  })
})

export default {
  props: {
    dialogFlowModel: {
      settings: {
        url: String,
        bearerToken: String,
        queryParamsTemplate: String,
        bodyTemplate: String
      }
    },
    errors: {
      settings: {
        bodyTemplate: String
      }
    }
  },

  data () {
    return {
      projectTypes: DialogFlowProjectTypes,
      dialogFlowUrl: DIALOG_FLOW_DOCS_URL
    }
  },

  computed: {
    settingsErrors () {
      return this.$props.errors.settings || {}
    },

    localDialogFlowModel: {
      get () {
        return this.$props.dialogFlowModel
      },
      set (value) {
        this.$emit('update:dialogFlowModel', value)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
    .engine__dialog-flow {
        .label {
            font-size: 14px;
            font-weight: bold;
            line-height: 16px;
        }
        .type-select {
            display: flex;
            justify-content: flex-start;
            margin: 16px 0;
            ::v-deep .ui-radio {
                margin-right: 20px;
                &.is-checked {
                    .ui-radio__outer-circle {
                        background-color: #2196f3;
                        border: none;
                    }
                    .ui-radio__inner-circle {
                        background-color: white;
                        transform: scale(.3);
                    }
                }
            }
        }
    }
</style>
